var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoNavbar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3000 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f6f6f6;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1639.62,2210.76c-27.67-17.1-49.99-41.52-64.54-70.62l-30.85-61.7-5.1,10.2,114.2,228.4c27.33,54.65,24.46,118.32-7.66,170.3-2.78,4.5-5.74,8.84-8.87,13.02h298.46c39.79,0,76.16-22.48,93.95-58.07l102.7-205.39h-400.27c-32.53,0-64.35-9.04-92.02-26.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2830.58,499.64h-432.03c-39.79,0-76.16,22.48-93.95,58.07l-348.65,697.3,333.45,666.91,635.13-1270.26c34.92-69.84-15.87-152.02-93.95-152.02Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2267.34,2044.28c-1.7-9.87-4.9-19.74-9.72-29.39l-7.35-14.71-333.45-666.91-19.57-39.13-19.57-39.13-181.92-363.85c-17.79-35.59-54.17-58.06-93.95-58.06h-432.03c-78.09,0-128.87,82.17-93.95,152.01l468.4,936.81,19.57,39.13,19.56,39.13,54.33,108.66c17.8,35.59,54.17,58.06,93.95,58.06h432.03c1.09,0,2.18-.02,3.26-.06,16.41-.47,31.55-4.6,44.86-11.47h.01c39.88-20.55,63.39-65.66,55.54-111.08h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1500,2166.9l-19.56-39.12h0s-19.57-39.14-19.57-39.14L695.4,557.71c-17.79-35.59-54.16-58.07-93.95-58.07H169.42c-78.08,0-128.87,82.18-93.95,152.02l895.32,1790.63c17.79,35.59,54.16,58.07,93.95,58.07h432.03c1.08,0,2.16-.02,3.23-.06,76.24-2.22,125.16-83.09,90.72-151.96l-90.72-181.44Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNavbar1);
export default __webpack_public_path__ + "static/media/LogoNavbar1.6a3f337ac26f3756be8e59fd7e08ae68.svg";
export { ForwardRef as ReactComponent };